//----------------------------------------------------/
//
//      T3NITSAN
//      Author: NITSAN
//
//----------------------------------------------------/


//Global var
var NITSAN = {},
        $ = jQuery.noConflict();
(function ($) {
    // USE STRICT
    "use strict";
    //----------------------------------------------------/
    // Predefined Variables
    //----------------------------------------------------/
    var $window = $(window),
            $body = $('body'),
            $header = $('header'),
            $navigation = $('.navigation'),
            $nav_arrow = $('.nav-arrow'),
            $megamenu = $('.mega-menu'),
            $menu_trigger = $('.menu-trigger'),
            $search_trigger = $('.search-trigger'),
            $top_nav = $('.top-nav'),
            $carousel = $('.carousel'),
            $thumb_owl_carousel = $('.thumb-slider'),
            $carousel_fullscreen = $('[data-carousel-fullscreen="true"]'),
            $go_top = $(".go-top"),
            $map = $('.map');
//            $masonry_layout = ('.grid');


    NITSAN.core = {
        functions: function () {
            // Call all Core Function e.g NITSAN.core.pageLoader();
        },
        // Define all core Functions e.g pageLoader: function () {}
    };
    NITSAN.header = {
        functions: function () {
            // Call all Function of header here e.g NITSAN.header.mainMenu();
            NITSAN.header.mobile_navigation();
        },
        // Define all Functions of header e.g mainMenu: function () {},
        mobile_navigation: function () {
            $menu_trigger.on('click', function () {
                $body.toggleClass('menu--open');
                $navigation.slideToggle('fast');
            });
            $nav_arrow.on('click', function () {
                if ($(this).parent().hasClass('has-megamenu')) {
                    $(this).parent('li').siblings('li').removeClass('sub--open').not('.has-megamenu').find('ul').slideUp('fast');
                    $(this).parent('li').siblings('li').removeClass('sub--open').find('.mega-menu').slideUp('fast');
                    $(this).parent('li').toggleClass('sub--open').find('.mega-menu').slideToggle('fast');
                } else {
                     $(this).parents('li').siblings('li').find('li').removeClass('sub--open');
                    $(this).parent('li').siblings('li').removeClass('sub--open').find('.mega-menu').slideUp('fast');
                    $(this).parent('li').siblings('li').removeClass('sub--open').not('.has-megamenu').find('ul').slideUp('fast');
                    $(this).parent('li').toggleClass('sub--open').find('ul').first().slideToggle('fast');
                }
                NITSAN.header.mobile_nav_maxheight();
            });
            if ($(window).width() > 768) {
                $(".navigation nav > ul > li a").one("click", false, function (e) {
                    if ("ontouchstart" in document.documentElement) {
                        e.preventDefault();
                    }
                });
                $(".navigation nav > ul > li.has-sub > ul > li a").one("click", false, function (e) {
                    if ("ontouchstart" in document.documentElement) {
                        e.preventDefault();
                    }
                });
                $(".navigation nav li a").on("touchstart", function (e) {
                    $(this).parent().siblings().find('ul', '.mega-menu').hide();
                    $(this).parent().find('ul', '.mega-menu').show();
                });
            }
        },
        mobile_nav_maxheight: function () {
            $navigation.css('max-height', NITSAN.general.win_h() - NITSAN.general.header_h());
        },
        top_nav: function () {
            if ($top_nav.length) {
                $header.addClass('has-top-nav');
            }
        }
    };

    NITSAN.slider = {
        functions: function () {
            // Call all function of slider here e.g NITSAN.slider.carousel();
            NITSAN.slider.bstrap_carousel();
            NITSAN.slider.bstrap_fullscreen_carousel();
            NITSAN.slider.thumb_carousel();

            $('[data-fancybox]').fancybox({
                loop: true
            });
        },
        // Define all functions of slider e.g carousel: function () {},
        bstrap_carousel: function () {
            $carousel.each(function () {
                $(this).carousel();
                if ($('.carousel-content').length) {
                    $(this).parents().find('.slider-section').addClass('content-slider-section');
                }
            });
        },
        thumb_carousel: function () {
            $thumb_owl_carousel.each(function () {
                $(this).owlCarousel({
                    items: 3,
                    autoplayTimeout: 3000,
                    autoplay: true,
                    dots: true,
                    nav: false,
                    animateIn: 'fadeIn',
                    animateOut: 'fadeOut',
                    loop: true,
                    margin: 10,
                    navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
                    responsive: {
                        0: {
                            items: 1,
                            touchDrag: true,
                            mouseDrag: true
                        },
                        600: {
                            items: 2,
                            touchDrag: true,
                            mouseDrag: true
                        },
                        1200: {
                            items: 3,
                            touchDrag: false,
                            mouseDrag: false
                        }
                    }

                });
            });
        },
        bstrap_fullscreen_carousel: function () {
            $carousel_fullscreen.each(function () {
                if (NITSAN.general.win_w() > 767) {
                    $(this).find('.carousel-item').height(NITSAN.general.win_h() - NITSAN.general.header_h());
                }
            });
        }
    };
    NITSAN.elements = {
        functions: function () {
            // Call all element functions here e.g NITSAN.elements.accordion();
            NITSAN.elements.goTop();
            NITSAN.elements.searchForm();
            NITSAN.elements.customMaps();
            NITSAN.elements.masonryLayout();
        },
        // Define all element functions e.g accordion: function () {},
        goTop: function () {
            $go_top.on('click', function () {
                $("html, body").animate({scrollTop: 0}, 1000);
                return false;
            });
        },
        masonryLayout: function () {
            $('.news-masonry').masonry({
                // options
                itemSelector: '.news-item',
                gutter: 0,
            });
        },
        searchForm: function () {
            $search_trigger.on('click', function () {
                $body.toggleClass('search-active');
                $(".search-wrapper input").focus().focus();
            });
        },
        customMaps: function () {
            if ($map.length > 0) {
                var dataLat, dataLong, dataZoom, pinIcon, dataMapType, dataPinIcon;
                dataLat = $map.data('map-lat') ? $map.data('map-lat') : '21.7612544';
                dataLong = $map.data('map-long') ? $map.data('map-long') : '72.1440407';
                dataZoom = $map.data('map-zoom') ? $map.data('map-zoom') : '14';
                dataMapType = $map.data('map-type') ? $map.data('map-type') : 'ROADMAP';
                dataPinIcon = $map.data('map-icon') ? $map.data('map-icon') : 'images/map-pin.png';
                init();
            }
            function init() {
                var map = new google.maps.Map(document.getElementById('map'), {
                    zoom: dataZoom,
                    center: {lat: dataLat, lng: dataLong}
                });
                setMarkers(map);
                function setMarkers(map) {
                    var image = {
                        url: dataPinIcon,
                    };
                    var marker = new google.maps.Marker({
                        position: {
                            lat: dataLat,
                            lng: dataLong
                        },
                        map: map,
                        icon: image
                    });
                }
            }
        }
    };
    NITSAN.general = {
        functions: function () {
            // Call all general functions here
        },
        // Define all general functions
        win_w: function () {
            return $(window).width();
        },
        win_h: function () {
            return $(window).height();
        },
        header_h: function () {
            return $header.outerHeight();
        }
    };

    //Document resize functions
    NITSAN.documentOnResize = {
        functions: function () {
            // Call all function which need to call on resize event e.g NITSAN.core.customHeight();
            NITSAN.slider.bstrap_fullscreen_carousel();
            NITSAN.header.mobile_nav_maxheight();
        },
    };
    $window.on('resize', NITSAN.documentOnResize.functions);

    //Document ready functions
    NITSAN.documentReady = {
        functions: function () {
            // Call above all function on document ready e.g. NITSAN.header.functions();
            NITSAN.header.functions();
            NITSAN.slider.functions();
            NITSAN.elements.functions();
        },
    };
    $(document).ready(NITSAN.documentReady.functions);

    //Document on load functions
    NITSAN.documentOnLoad = {
        functions: function () {
            // Call function which need to load after page load e.g. NITSAN.header.functions();
        },
    };
    $(window).on('load', NITSAN.documentOnLoad.functions);

    //Document Scroll functions
    NITSAN.documentScroll = {
        functions: function () {
            // Call function which need to load on page scroll e.g. NITSAN.header.stickyHeader();
        },
    }
    ;
    $window.on('scroll', NITSAN.documentScroll.functions);
})(jQuery);